import React from "react";
import { InvoiceIcon } from "../../../Icons";
import { staffPayRateApi } from "../../../services/librariesCatalogService";
import LibraryCatalogPage, {
  cellMuted,
  cellStrong,
} from "../components/LibraryCatalogPage";
import StaffPayRateFormModal from "./StaffPayRateFormModal";

const columns = [
  {
    header: "Visit Note",
    accessor: "visitNote",
    sortable: true,
    strong: true,
    className: "whitespace-nowrap px-3 min-w-[8rem]",
  },
  {
    header: "Role",
    accessor: "roleName",
    sortable: true,
    render: (row) => <span className={cellStrong}>{row.roleName || "—"}</span>,
  },
  {
    header: "User",
    accessor: "userName",
    render: (row) => (
      <span className="text-[13px] text-slate-800">{row.userName || "—"}</span>
    ),
  },
  {
    header: "Rate",
    accessor: "rate",
    sortable: true,
    render: (row) => (
      <span className={`${cellMuted} tabular-nums`}>
        {row.rateDisplay ||
          (row.rate == null ? "—" : `$${Number(row.rate).toFixed(2)}`)}
      </span>
    ),
  },
  {
    header: "Code",
    accessor: "code",
    sortable: true,
    render: (row) => (
      <span className={`${cellMuted} tabular-nums`}>{row.code || "—"}</span>
    ),
  },
];

const StaffPayRatesPage = () => (
  <LibraryCatalogPage
    title="Staff Pay Rates"
    icon={InvoiceIcon}
    addLabel="Create New"
    searchPlaceholder="Search by visit, role, user, code..."
    entityLabel="Staff pay rate"
    defaultSortBy="visitNote"
    api={staffPayRateApi}
    columns={columns}
    FormModal={StaffPayRateFormModal}
    getDeleteLabel={(row) =>
      `${row.visitNote} · ${row.roleName} · ${row.userName || "User"}`
    }
  />
);

export default StaffPayRatesPage;
